/* eslint-disable import/no-unresolved */
// import { useState } from "react";
// eslint-disable-next-line import/no-unresolved
import CustomStepper from "src/shared/CustomStepper";
import DetailsHeading from "src/shared/DetailsHeading";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import { showNewVersionUW } from "src/helpers/FormDetails/ProposalDetails/resources";
import ProposerReview from "./ProposerReview";
import NomineeReview from "./NomineeReview";
import MedicalAndLifeStyle from "./MedicalLifestyle";
import CovidAndNri from "./CovidAndNri";
import GeneralReview from "./GeneralReview";
import LoanReview from "./LoanReview";
import JointLife from "./JointLife";
import AssignmentNoticeReview from "./AssignmentNoticeReview";
import MedicalAndLifeStyleV2 from "./MedicalAndLifeStyleV2";

function Review() {
  const isJointAddendumState = useAppSelector((state: any) => state.isJointAddendum.isJointState);
  const reviewStepNumber = useAppSelector((state): any => state.stepDetails.reviewStepNo);
  const nomineeDetails = useAppSelector((state) => state.proposerDetails.nominee?.nominee || []);
  const assignmentNotice = useAppSelector((state) => state?.common?.assignmentStepperFlag);
  const nationality = useAppSelector((state) => state.proposerDetails?.general?.nationalityCode);
  const primaryMembersData = useAppSelector((state) => state?.common?.leadDetails?.Members)?.filter(
    (e: any) => !e?.isJointMember
  )[0];

  const steps = [
    {
      label: "General Details",
      enable: true,
      component: <GeneralReview />
    },
    {
      label: "Proposer",
      enable: true,
      component: <ProposerReview />
    },
    {
      label: "Nominee",
      enable: !!nomineeDetails[0].id,
      component: <NomineeReview />
    },
    {
      label: "Medical & Lifestyle",
      enable: true,
      component: showNewVersionUW(primaryMembersData) ? (
        <MedicalAndLifeStyleV2 />
      ) : (
        <MedicalAndLifeStyle />
      )
    },
    {
      label: "NRI Details",
      enable: !!(nationality !== "RES"),
      component: <CovidAndNri />
    },
    {
      label: "Joint Life",
      enable: !!(isJointAddendumState === "yes"),
      component: <JointLife />
    },
    {
      label: "Assignment Notice",
      enable: !!assignmentNotice,
      component: <AssignmentNoticeReview />
    },
    {
      label: "Loan Details",
      enable: true,
      component: <LoanReview />
    }
  ];

  return (
    <div className="bg-whiteSmoke pt-8 pb-19.5 font-montserrat">
      <div className="xl:w-290 mx-auto bg-white pt-8.5 rounded-1.5xl">
        <div className="pr-10 pl-10.25">
          <DetailsHeading label="Review Details" />
        </div>
        <CustomStepper
          steps={steps?.filter((ele) => ele?.enable)?.map((ele) => ele.label)}
          currentStep={reviewStepNumber}
          showBackArrow={false}
          stepperValue="review"
          leftSpacingClasses="w-8/100"
          rightSpacingClasses="w-68/1000"
          circleSizeClasses="h-6 w-6"
        />
        <div className="mt-8">
          {steps?.filter((ele) => ele?.enable)?.[reviewStepNumber - 1]?.component}
        </div>
      </div>
    </div>
  );
}

export default Review;
